import { Capacitor, registerPlugin } from "@capacitor/core";
import { HUNTER_URL } from "Components/Hunter/hunterUrl";

// Bridge to the native "Hunter" Capacitor plugin (iOS: HunterPlugin.swift in the
// moone-ios repo; Android: HunterPlugin.java in the Capacitor shell). Presents a
// full-screen, chromeless native WebView loading hunter as a TOP-LEVEL document — so
// hunter's frame-ancestors / X-Frame-Options don't apply (unlike the web iframe).
// Only call this on a native platform (isNativePlatform()).
export type HunterPlugin = {
  open(options: { url: string }): Promise<void>;
};

export const HunterNative = registerPlugin<HunterPlugin>("Hunter");

// True when the running shell actually contains the plugin (iOS: registered in
// MooneViewController.capacitorDidLoad; Android: MainActivity.onCreate), before the web
// app loads. False on app builds that predate the plugin — registerPlugin above has no
// web fallback implementation, so calling open() there rejects with an "Unimplemented"
// exception. Callers must degrade to a browser surface instead.
export const isHunterNativeAvailable = () =>
  Capacitor.isPluginAvailable("Hunter");

export const openHunterNative = () => HunterNative.open({ url: HUNTER_URL });
